import React from 'react';
import style from './FriendCard.module.css';
import formatDisplayName from '../../utils/formatDisplayName';
import VerifiedBadge from '../VerifiedBadge/VerifiedBadge';

const FriendCard = props => {
	return (
		<div className={style.FriendCardWrapper}>
			<div className={style.FriendInfo}>
					<img
						src={props.profileImage}
						alt=""
						className={style.ProfileImage}
					/>

				<span className={style.FriendUsername}>
					{formatDisplayName(props.username)}
					<VerifiedBadge userPlan={props.userPlan} totalXP={props.totalXP} size='small' />
				</span>
			</div>

			<span className={style.FriendPoints}>

			</span>
		</div>
	)
}

export default FriendCard;